import ENGLISH_PHRASE from "../../constants/multi-languages/en";
import PORTUGESE_PHRASE from "../../constants/multi-languages/pt";
import FRENCH_LANGUAGE from "../../constants/multi-languages/fr";
import DEUTSCH_PHRASE from "../../constants/multi-languages/de";
import SPANISH_PHRASE from "../../constants/multi-languages/es";
import DUTCH_PHRASE from "../../constants/multi-languages/nl";
import GREEK_PHRASE from "../../constants/multi-languages/el";

const state = {
    language: ""
};

const mutations = {
    setLanguage(state, payload) {
        state.language = payload;
    },
};

const actions = {
    setLanguage({ commit }, payload) {
        commit("setLanguage", payload);
    },
};

const getters = {
    language(state) {
        return state.language;
    },
    listMultiLanguages() {
        return [
            {
                key: 'en',
                labels: [
                    'english', 'en'
                ],
                local: 'en-US',
                value: ENGLISH_PHRASE
            },
            {
                key: 'fr',
                labels: [
                    'french', 'fr', 'française', 'français'
                ],
                local: 'fr-FR',
                value: FRENCH_LANGUAGE
            },
            {
                key: 'pt',
                labels: [
                    'portugal', 'português', 'portuguese'
                ],
                local: 'pt-PT',
                value: PORTUGESE_PHRASE
            },
            {
                key: 'de',
                labels: [
                    'deutsch', 'de', 'german', 'germany'
                ],
                local: 'de-DE',
                value: DEUTSCH_PHRASE
            },
            {
                key: 'es',
                labels: [
                    'spanish', 'es', 'español'
                ],
                local: 'es-ES',
                value: SPANISH_PHRASE
            },
            {
                key: 'nl',
                labels: [
                    'dutch', 'nl', 'nederlands'
                ],
                local: 'nl-NL',
                value: DUTCH_PHRASE
            },
            {
                key: 'el',
                labels: [
                    'greek', 'el', 'greece', 'hellenic'
                ],
                local: 'el-GR',
                value: GREEK_PHRASE
            },
        ];
    },
    multiLanguageObjects(state, getters, rootState, rootGetters) {
        // Find multi language value;
        const listLanguages = getters.listMultiLanguages;
        let lang;
        // User language
        if (state.language) {
            lang = state.language;
        }
        // Agency language
        if (!lang) {
            if (rootGetters.dashboardLanguage) {
                lang = rootGetters.dashboardLanguage;
            }
        }
        let result = listLanguages[0];
        if (lang) {
            const langObj = listLanguages.find(langObj => langObj.labels.includes(lang.toLowerCase()));
            if (langObj) {
                result = langObj;
            }
        }
        return result;
    },
    multiLanguageValues(state, getters) {
        return getters.multiLanguageObjects.value;
    },
    languageLocal(state, getters) {
        return getters.multiLanguageObjects.local;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/language.js